export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-b from-primary-50/60 via-background-50/40 to-background-50 z-0"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-6">
              <i className="ri-fire-line"></i>
              <span>最新影视 · 高清免费 · 不缓冲</span>
            </div>

            <h1 className="text-3xl md:text-5xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-4">
              天美麻花星空影视免费观看
              <span className="block text-primary-600 text-2xl md:text-3xl lg:text-3xl mt-2">
                电影在线观看 · 电视剧免费 · 综艺高清
              </span>
            </h1>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4 max-w-xl mx-auto lg:mx-0">
              天美麻花星空影视免费观看汇聚海量影视视频资源，覆盖电影在线观看、电视剧免费追剧、综艺节目高清播放。依托91电影视频与麻豆影视在线观看等优质内容渠道，每日更新最新影视，播放流畅不缓冲，为用户打造一站式免费观影新体验。
            </p>
            <p className="text-sm text-foreground-500 leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0">
              本站持续追踪热门影视动态，覆盖动作、喜剧、悬疑、爱情、科幻等多题材分类，无论您喜欢经典老片还是最新院线，都能在这里找到心仪内容。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-600">2W+</div>
                <div className="text-xs text-foreground-500 mt-1">影视资源</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-500">每日更新</div>
                <div className="text-xs text-foreground-500 mt-1">内容同步</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-secondary-500">高清流畅</div>
                <div className="text-xs text-foreground-500 mt-1">不缓冲</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#media"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#media')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3 text-sm font-medium text-background-50 bg-primary-500 rounded-lg hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
              >
                立即观影
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href="#index"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3 text-sm font-medium text-foreground-700 bg-background-100 border border-background-300 rounded-lg hover:bg-background-200 transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
              >
                浏览专题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex items-center justify-center">
            <div className="relative w-full max-w-[520px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20warm%20golden%20atmosphere%20with%20abstract%20film%20reel%20and%20projector%20light%20beams%20on%20dark%20background%2C%20elegant%20movie%20entertainment%20vibe%2C%20professional%20cinematography%20aesthetic%20with%20soft%20lens%20flare%2C%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20creative%20composition%20with%20floating%20film%20frames%2C%20premium%20quality%20atmospheric%20lighting%2C%20subtle%20particle%20effects&width=1040&height=780&seq=hero-main-visual-01&orientation=landscape"
                alt="天美麻花星空影视免费观看 - 影视在线观看平台主视觉"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/20 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}